import { SupportedLocale } from "@/enums/locale.enum";

import ar from "@/../locales/ar/common.json";
import el from "@/../locales/el/common.json";
import en from "@/../locales/en/common.json";
import es from "@/../locales/es/common.json";
import fr from "@/../locales/fr/common.json";
import ru from "@/../locales/ru/common.json";

export const localizedMessagesSources: Record<SupportedLocale, unknown> = {
  [SupportedLocale.AR]: ar,
  [SupportedLocale.EL]: el,
  [SupportedLocale.EN]: en,
  [SupportedLocale.ES]: es,
  [SupportedLocale.FR]: fr,
  [SupportedLocale.RU]: ru,
} as const;
